import * as React from 'react';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import {Avatar, Box, Sheet, Stack, Textarea, useColorScheme} from '@mui/joy';
import Swal from 'sweetalert2';
import emailjs from 'emailjs-com';
import {theme} from "./../Theme";
import {Check, Circle} from "@mui/icons-material";
import {ProjectRepository} from "../repository/ProjectRepository";
import {useEffect, useRef, useState} from "react";
import {SummaryModel} from "../model/summary";
import LoadingPage from "./Loading";
import TimeOutPage from "./TimeOut";
function ContactPage() {
    const repo = new ProjectRepository()
    const [summary, setSummary] = useState<SummaryModel>(new SummaryModel());
    const [error, setError] = useState<boolean>(false);
    const {mode, setMode} = useColorScheme();
    const SERVICE_ID = "service_iin6n09";
    const TEMPLATE_ID = "template_bx313gl";
    const PUBLIC_KEY = "bTFSiuXA0zjLbu4Ig";
    useEffect(() => {
        repo.getSummary().then(value => {
            if (value.profile.length > 0) {
                setSummary(value);
            }
        }).catch(reason => setError(true));
    })
    const handleOnSubmit = (e: any) => {
        e.preventDefault();
        emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target, PUBLIC_KEY)
            .then((result) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Thank you, Message Sent Successfully',
                    confirmButtonColor: mode === 'dark' ?
                        theme.colorSchemes.dark.palette.primary.solidBg :
                        theme.colorSchemes.light.palette.primary.solidBg
                })
                e.target.reset()
            }, (error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Ooops, something went wrong',
                    text: error.text,
                    confirmButtonColor: mode === 'dark' ?
                        theme.colorSchemes.dark.palette.primary.solidBg :
                        theme.colorSchemes.light.palette.primary.solidBg
                })
                e.target.reset()
            });
    };
    return (
        <Box paddingX={{xs: 2, md: 6}} sx={{bgcolor: 'background.surface'}}>
            <Sheet sx={{minHeight: '100vh', paddingX: 2, paddingY: 2, alignItems: 'center', justifyContent: 'center'}}>
                <Stack alignItems={{xs: 'center', md: 'flex-start'}}
                       justifyContent={{xs: 'center', md: 'space-between'}} spacing={{xs:0, ms:2}}
                       direction={{xs: 'column', md: 'row'}}>
                    <Stack direction = 'column'>
                        <Typography level="h4" fontWeight='bolder'>
                            You have a&nbsp;
                            <Typography color='primary'>Project</Typography>
                            &nbsp;or you want&nbsp;
                            <Typography color='primary'>Hire Me </Typography> ?
                            <br/>Let's Talk !
                        </Typography>
                        <br/>
                        {(summary.profile.length > 0 && !error) && (
                            <Box display={{xs: 'none', lg: 'block'}}>
                                <Typography startDecorator={<Check color='primary'/>}>{summary.yearsOfExperience}+ Years
                                    Of
                                    Experience</Typography>
                                <Typography
                                    startDecorator={<Check color='primary'/>}>{summary.highestGrade}</Typography>
                                {summary.role.map(value => (
                                    <Typography startDecorator={<Check color='primary'/>}>{value}</Typography>
                                ))}
                            </Box>
                        )}
                    </Stack>
                    <Sheet
                        variant='plain'
                        sx={{
                            //maxHeight: 'max-content',
                            maxWidth: '100%',
                            //mx: 'auto',
                            // to make the demo resizable
                            //overflow: 'auto',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: 0

                        }}
                    >
                        <form onSubmit={handleOnSubmit}>
                            <Stack spacing={2}
                                   sx={{
                                       display: 'grid',
                                       gridTemplateColumns: 'repeat(2, minmax(80px, 340px))',
                                       gap: 1.5,
                                   }}>
                                <Input name="to_name" value="Fetchner Usman Monney" sx={{display: "none"}}/>
                                <Input name="to_email" value="monneyfetcherusman@gmail.com" sx={{display: "none"}}/>
                                <FormControl sx={{gridColumn: '1/-1'}}>
                                    <FormLabel>Name</FormLabel>
                                    <Input variant='soft' fullWidth required name="from_name" placeholder="Enter your name" size='md'/>
                                </FormControl>
                                <FormControl sx={{gridColumn: '1/-1'}}>
                                    <FormLabel>Email</FormLabel>
                                    <Input variant='soft' fullWidth required name="from_email" placeholder="Enter your email" size='md'/>
                                </FormControl>
                                <FormControl sx={{gridColumn: '1/-1'}}>
                                    <FormLabel>Subject</FormLabel>
                                    <Input variant='soft' fullWidth name="subject" placeholder="Enter subject here please..." size='md'/>
                                </FormControl>
                                <FormControl sx={{gridColumn: '1/-1'}}>
                                    <FormLabel>Message</FormLabel>
                                    <Textarea variant='soft' required name="message" minRows={3} placeholder="Enter your message here please..." size='md'/>
                                </FormControl>
                                <CardActions sx={{gridColumn: '1/-1'}}>
                                    <Button type='submit' variant="solid" color="primary">
                                        Submit
                                    </Button>
                                </CardActions>
                            </Stack>
                        </form>
                    </Sheet>
                </Stack>
            </Sheet>
        </Box>
    );
}
export default ContactPage;